import PatientsTable from "../../../components/PatientsTable/PatientsTable";

function ChainPatients() {
    return (
        <>
            <PatientsTable userType={3} />
        </>
    )
}

export default ChainPatients;
